module.exports = __webpack_public_path__ + "static/img/14areaB_4.eda2fdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/14areaB_4.png
// module id = 1127
// module chunks = 1